import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FocusInputDirective } from '@core/directives/focus-input.directive';

@Component({
    selector: 'app-editable-input-field',
    imports: [FocusInputDirective, CommonModule, FormsModule],
    templateUrl: './editable-input-field.component.html',
    styleUrls: ['./editable-input-field.component.scss']
})
export class EditableInputFieldComponent {
  @Input() text: string = '';
  @Input() textClass: 'default' | 'modified' = 'default'
  @Input() maxInputLength: number | null;
  @Output() textChange = new EventEmitter<string>();

  initialText: string;

  showText: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['text']) {
      const latestChanges = changes['text'].currentValue as string;
      this.initialText = latestChanges.trim();
    }

  }

  saveText() {
    this.text = this.text.trim();
    if (this.text !== this.initialText) {
      this.textChange.emit(this.text);
    }

    if (this.text === '') {
      this.showText = true;
    } else {
      this.showText = false;
    }
  }

  onEnter(event: Event) {
    if ((event as KeyboardEvent).key === 'Enter') {
      this.saveText();
    }
  }
}
